import { createResourceSelectors } from "src/redux_resources_v1";

export const woundAssessmentsResourceSelectors = createResourceSelectors(
  "woundAssessments"
);
